import { getCookie, setCookie } from 'cookies-next'

export const getGoogleAnalyticsClientId = async () => {
  const gaCookie = await getCookie('_ga')

  if (gaCookie && typeof gaCookie === 'string') {
    const [, , clientIdFirst, clientIdSecond] = gaCookie.split('.')

    return `${clientIdFirst}.${clientIdSecond}`
  }

  return 'No Google Analytics cookies found'
}

export const getSearchEngine = (): string => {
  return getCookie('ag_srch_eng') as string
}

export const getSearchType = async () => {
  const paidSearchCookie = await getCookie('ag_pd')
  const isPaidSearch = paidSearchCookie === 'true'
  return isPaidSearch ? 'paid' : 'organic'
}

export const saveSearchEngine = async (referrer: string) => {
  const searchEngineKey = 'ag_srch_eng'
  // check if ag_srch_eng in cookie is empty.
  const searchEngineCookie = await getCookie(searchEngineKey)

  // if cookie not found:
  if (!searchEngineCookie) {
    // then parse the search engine from the referrer
    const searchEngine = parseSearchEngine(referrer)

    // save into cookie the search engine
    setCookie(searchEngineKey, searchEngine)
  }
}

export const savePaidSearch = async () => {
  const paidSearchKey = 'ag_pd'

  // check if ag_pd in cookie is empty.
  const paidSearchCookie = await getCookie(paidSearchKey)

  // if cookie not found:
  if (!paidSearchCookie) {
    // save into cookie the search engine
    setCookie(paidSearchKey, true)
  }
}

const parseSearchEngine = (referrer: string): string => {
  if (!referrer || referrer === '') {
    return '' // No referrer provided
  }

  const searchEngines = {
    google: /(?:https?:\/\/)?(?:www\.)?google\.[a-z]{2,}(?:\.[a-z]{2})?/i,
    bing: /(?:https?:\/\/)?(?:www\.)?bing\.[a-z]{2,}(?:\.[a-z]{2})?/i,
    yahoo: /(?:https?:\/\/)?(?:www\.)?yahoo\.[a-z]{2,}(?:\.[a-z]{2})?/i,
    duckduckgo: /(?:https?:\/\/)?(?:www\.)?duckduckgo\.[a-z]{2,}(?:\.[a-z]{2})?/i,
    ecosia: /(?:https?:\/\/)?(?:www\.)?ecosia\.[a-z]{2,}(?:\.[a-z]{2})?/i,
  }

  for (const [engine, regex] of Object.entries(searchEngines)) {
    if (referrer.match(regex)) {
      return engine
    }
  }

  return '' // Referrer doesn't match known search engines
}
